var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBGclassic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 598,
    viewBox: "0 0 403 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 503,
    fill: "url(#paint0_linear_535_112)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 158,
    width: 403,
    height: 346,
    fill: "url(#paint1_linear_535_112)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_535_112",
    x1: -0.00000240293,
    y1: 4.72174,
    x2: 427.062,
    y2: 248.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "color-grad-1",
    stopColor: "#061BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "color-grad-2",
    offset: 1,
    stopColor: "#2539C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_535_112",
    x1: 201,
    y1: 158,
    x2: 201.35,
    y2: 473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "bg-class-1",
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "bg-class-2",
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGclassic);
export default __webpack_public_path__ + "static/media/BGclassic.2b9c6cc348cc7e5bb11d2f85c56a017f.svg";
export { ForwardRef as ReactComponent };